// TODO: ADD links and email
export const FACEBOOK_URL =
    "https://www.facebook.com/Top-7-Reasons-102818484954560/";
export const TWITTER_URL = "https://twitter.com/Top7Reasons";
export const INSTAGRAM_URL = "https://www.instagram.com/top7reasons/";
export const CONTACT_EMAIL = "customerservice@top7reasons.com";

export const CAPTCHA_KEY = "6LfYDtcZAAAAAI-2DQmo1nMOj6PDTFzIAh2EP1EP";
